import React, { FC } from 'react';

import { Loader } from '@opendoor/bricks/core';
import { MarginProps } from '@opendoor/bricks/system/theme';

import { Section } from 'shared/components/Section';
import { TaskCardProps } from 'shared/components/TaskCard';
import { TasksSectionContent } from 'shared/components/TasksSectionContent';

interface IOptionalClosingTasks {
  tasks: undefined | TaskCardProps[];
  loading: boolean;
}

/**
 * Renders closing tasks
 * component-test-check-ignore
 */
export const ClosingTasksSection: FC<IOptionalClosingTasks & MarginProps> = ({
  tasks,
  loading,
  ...marginProps
}) => (
  <Section title="To do" {...marginProps}>
    {loading && <Loader />}
    {!loading && tasks && <TasksSectionContent tasks={tasks} />}
  </Section>
);
